import { BaseEnum } from "@/types/base";
import { useI18n } from "vue-i18n";

export const getName = (item: BaseEnum) => {
  const { locale } = useI18n();
  if (locale.value == "zh") return item.cname;
  return item.name;
};

export const getLocaleName = (item: BaseEnum, locale: string) => {
  if (locale == "zh") return item.cname;
  return item.name;
};
